import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LoadPostsecondaryCalculatedFields } from './../../../../ng2/store/actions/students-actions/calculated-fields-action';
import {
  getCalculatedFieldsEntitiesList,
  getCalculatedFieldsLoadedStatus,
} from './../../../../ng2/store/selectors/calculated-fields-selector';
@Injectable()
export class CalculatedFieldsResolver {
  resolveCalculatedField$(currentSchool, store): Promise<Observable<any>> {
    const payload = { schoolId: currentSchool._id };
    const destroy$: Subject<boolean> = new Subject<boolean>();

    return new Promise(resolve => {
      store
        .select(getCalculatedFieldsLoadedStatus)
        .takeUntil(destroy$)
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new LoadPostsecondaryCalculatedFields(payload));
          if (loaded) {
            const dashboardStudents$ = store.select(getCalculatedFieldsEntitiesList);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(dashboardStudents$);
          }
        });
    });
  }
}
